<template>
  <div class="container">
    <div class="columns">
      <div class="column card is-offset-3 is-6 content has-text-centered">
        <div class="p-md">
          <h3 v-text="$wording.register.activate_1" />
          <p v-text="$wording.register.activate_2" />
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Activate',
  async beforeMount() {
    if (!this.$route.query.userId || !this.$route.query.emailToken) {
      this.$router.push({ name: 'register-error' });
      return;
    }

    const response = await this.$store.dispatch('users/validateAccount', {
      authToken: encodeURIComponent(this.$route.query.emailToken),
      userId: this.$route.query.userId,
    });
    if (response) {
      this.$sCache.set('flash-message',
        { type: 'success', message: `Your account is now active and ready to use.` }
      );
      document.location = this.$router.resolve({ name: 'login' }).href;
    } else {
      document.location = this.$router.resolve({ name: 'register-error' }).href;
    }
  },
};
</script>